import { render } from "./VolumeReports.vue?vue&type=template&id=1d9dca38"
import script from "./VolumeReports.vue?vue&type=script&lang=js"
export * from "./VolumeReports.vue?vue&type=script&lang=js"

import "./VolumeReports.vue?vue&type=style&index=0&id=1d9dca38&lang=css"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__